export * from './deckgl-info.interface';
